/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Contact_Topic_InspectionInputs */



/**
* | output |
* | --- |
* | "Inspection or survey enquiry" |
*
* @param {Contact_Topic_InspectionInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
export const contact_topic_inspection = /** @type {((inputs?: Contact_Topic_InspectionInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Contact_Topic_InspectionInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return /** @type {LocalizedString} */ ("检查或检验咨询")
	return /** @type {LocalizedString} */ ("Inspection or survey enquiry")
});